// src/product.ts
var hasProductVariantVersion = variant => Boolean(variant.attributes.find(attr => attr.name === "Product_Version___LOV"));
var getProductVariantVersion = variant => {
  const variantVersion = variant.attributes.find(attr => attr.name === "Product_Version___LOV");
  return variantVersion ? variantVersion.value[0].key : "1";
};
export { hasProductVariantVersion, getProductVariantVersion };